export default __webpack_public_path__ + "static/ClarityNuvo-Regular-1848eb63b8f8835906ffb94c3d1da562.woff";